import { notification } from "antd";
import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE, } from "../Types";
import { DcOffLineHost } from "../../config";

export const resetPassword = ({ token, newPassword }) => {
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_REQUEST });

    try {
      const response = await fetch(`${DcOffLineHost}api/users/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,                     
          newPassword,
        }),
      }
    );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Erreur");
      }

      dispatch({ type: RESET_PASSWORD_SUCCESS, payload: data });

      notification.success({
        message: data?.message,
        duration: 5,
      });

      return data;

    } catch (error) {
      dispatch({ type: RESET_PASSWORD_FAILURE, payload: { error: error?.message }, });
    

      // notification.error({
      //   message: error.message,
      //   duration: 5,
      // });
    }
  };
};
